export * from './has-permission.pipe';

